import React from 'react';
import ReactDOM from 'react-dom';
import Store from './store/Store';
ReactDOM.render(<Store/>,document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js